import React, { useState } from "react";
import "./index.css";
import {
  Col,
  Form,
  Input,
  Row,
  Button,
  DatePicker,
  Radio,
  InputNumber,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";

const Index = ({setActive}) => {
  const [form] = Form.useForm();
  const [retainer, setRetainer] = useState(false);
  const [broker, setBroker] = useState(true);
  const [payment, setPayment] = useState(false);

  const submit = async (values) => {
    setActive(true)
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/renant-rental-fee`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    console.log(values);
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Tenant Fee"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false)
  };
  const method_change = (e) => {
    if (e.target.value == "retainer") {
      setRetainer(e.target.value);
      setBroker(false);
    } else {
      setBroker(e.target.value);
      setRetainer(false);
    }
  };
  const methodChange = (e) => {
    console.log(e.target.value);
    if (e.target.value == "other") {
      setPayment(e.target.value);
    } else {
      setPayment(false);
    }
  };
  return (
    <div className="main">
      <Form
        form={form}
        onFinish={submit}
        initialValues={{
          tenancy_creation: "prospective_tanant_shall_not",
          TENANT_payment_method: "brokers_fee",
          Broker_Fee_Responsibility: "will_not",
          brooker_payment_method: "check",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <label>Tenant Representation Agreement</label>
        </div>

        <Row
          gutter={16}
          justify={"space-between"}
          style={{ marginTop: "1.2rem" }}
        >
          <Col md={10}>
            <label>Tenant's Name</label>
            <Form.Item
              name={"Tenant_name"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="Tenant Name" />
            </Form.Item>
          </Col>
          <Col md={10}>
            {" "}
            <label>Broker's Name</label>
            <Form.Item
              name={"Tenant_broker_mutualPromises"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-between"}>
          <label style={{ marginTop: "1rem" }}>Term Of Agreement:</label>
          <Col md={10}>
            <label>Start</label>
            <Form.Item
              name={"tenant_broker_agrement_start_date"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={10}>
            <label>End</label>
            <Form.Item
              name={"tenant_broker_agrement_end_date"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>
        <label>TENANT agrees to pay BROKER</label>
        <Form.Item
          name="TENANT_payment_method"
          rules={[{ required: true, message: "required" }]}
        >
          <Radio.Group onChange={method_change}>
            <Row gutter={16} justify={"space-between"}>
              <Radio value={"retainer"}>Retainer</Radio>
              <Col md={24} style={{ marginLeft: "2rem" }}>
                {retainer && (
                  <>
                    <div style={{ width: "50%" }}>
                      {" "}
                      <label>Retainer Payment for Broker Services</label>
                      <Form.Item
                        name={"Retainer_Payment_for_Broker_Services"}
                        rules={[{ required: true, message: "required!" }]}
                      >
                        <Input placeholder="Retainer Payment for Broker Services" />
                      </Form.Item>
                      <Form.Item
                        name={"retainer_credit"}
                        rules={[{ required: true, message: "required!" }]}
                      >
                        <Select placeholder="Select an option">
                          <Select.Option value={"tenant_retainer_shall"}>
                            Shall be credited to broker fee
                          </Select.Option>
                          <Select.Option value={"tenant_retainer_shall_not"}>
                            Shall not be credited to broker fee
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </>
                )}
              </Col>
              <Radio value={"brokers_fee"}>Broker’s Fee</Radio>
              <Col md={24} style={{ marginLeft: "2rem" }}>
                {broker && (
                  <>
                    {" "}
                    <Form.Item
                      name={"brokers_fee_parties_amount"}
                      rules={[{ required: true, message: "required!" }]}
                    >
                      <Input placeholder="$" />
                    </Form.Item>
                    <label>payment due</label>
                    <Form.Item
                      name={"brokers_completion_agreement_days"}
                      rules={[{ required: true, message: "required!" }]}
                      initialValue={7}
                    >
                      <InputNumber addonAfter="days" readOnly />
                    </Form.Item>
                  </>
                )}
              </Col>
            </Row>
          </Radio.Group>
        </Form.Item>
        <label>Other Provisions</label>
        <Form.Item name="Other_Provisions">
          <TextArea rows={4} placeholder="Other Provisions" />
        </Form.Item>
        <hr />
        <label>Brokers Rental Fee Disclosure</label>

        <Form.Item
          name={"propective_talent_amount"}
          rules={[{ required: true, message: "required!" }]}
        >
          <Input placeholder="Broker Fee $" style={{ width: "50%" }} />
        </Form.Item>
        <label>Time of payment</label>
        <Row
          gutter={16}
          justify={"space-between"}
          style={{ marginTop: "1rem" }}
        >
          <Col md={10}>
            <label>A: Payment due upon signing this document</label>
            <Form.Item
              name={"Payment_Signing_Document"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={10}>
            <label>B: Payment due upon signing a rental application</label>
            <Form.Item
              name={"Payment_Signing_Rental_Application"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-between"}>
          <Col md={10}>
            <label>
              C: Payment upon signing a lease or other rental agreement
            </label>
            <Form.Item
              name={"propective_talent_amount"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={10}>
            <label>D: Payment upon another event</label>
            <Form.Item
              name={"Payment_Other_Event"}
              rules={[{ required: true, message: "required" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name={"Payment_Other_Event_fill"}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <label>Tenancy not created</label>
        <Row
          gutter={16}
          justify={"space-between"}
          style={{ marginTop: "1.2rem" }}
        >
          <Col md={12}>
            <label>Prospective tenant</label>
            <Form.Item
              name={"tenancy_creation"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group>
                <Col md={24}>
                  <Radio value="prospective_tanant_shall">Shall</Radio>
                </Col>
                <Col md={24}>
                  <Radio value={"prospective_tanant_shall_not"}>
                    Shall not
                  </Radio>
                </Col>
              </Radio.Group>
            </Form.Item>
          </Col>
          {/* <Col md={12}>
            <label>Refund of amount</label>
            <Form.Item
              name={"refund_of_pervious_amount"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group>
                {" "}
                <Radio value="Full">Full</Radio>
                <Radio value={"Partial"}>Partial</Radio>
              </Radio.Group>
            </Form.Item>
            <label>Refund amount details</label>
            <Form.Item
              name={"previous_amount_details"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
          </Col> */}
        </Row>
        <hr />
        <label>Broker Fee Responsibility</label>
        <Form.Item
          name={"Broker_Fee_Responsibility"}
          rules={[{ required: true, message: "required" }]}
        >
          <Radio.Group>
            <Radio value={"will"}>will</Radio>
            <Radio value={"will_not"}>will not</Radio>
          </Radio.Group>
        </Form.Item>
        <label>Reciept of payment</label>
        <Row gutter={16} justify={"space-between"}>
          <Col md={10} style={{ marginTop: "1.4rem" }}>
            {" "}
            <label>Type or payment recieved</label>
            <Form.Item
              name={"propective_talent_amount"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="$" />
            </Form.Item>
          </Col>
          <Col md={10} style={{ marginTop: "1.4rem" }}>
            <label>Broker Recieved Payment date</label>
            <Form.Item
              name={"brooker_payment_date"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name={"brooker_payment_method"}
          rules={[{ required: true, message: "required!" }]}
        >
          {/* <Radio.Group onChange={methodChange}> */}
          <Radio.Group>
            {/* <Radio value={"cash"}>cash</Radio> */}
            <Radio value={"check"}>check</Radio>
            {/* <Radio value={"credit_card"}>credit card</Radio>
            <Radio value={"other"}>other</Radio> */}
            {payment && (
              <Form.Item
                style={{ marginLeft: "1rem" }}
                name={"other_payment_method_detail"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input placeholder="detail" />
              </Form.Item>
            )}
          </Radio.Group>
        </Form.Item>
        <Row gutter={[12, 12]}>
          <Col md={12}>
            <label>Name of real estate brokerage firm and licene number</label>
            <Form.Item
              name={"real_estate_brokerage_licence_num"}
              initialValue={"Vicente Realty ,LLC #9799"}
            >
              <Input readOnly />
            </Form.Item>
          </Col>
        </Row>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default Index;
